import API from '@services/API';

import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { configs } from '@constants/configs/configs';
import { NOTE_TYPES } from '@modules/members/account-activity/common/accountActivity.constants';
import { IAccountActivityEvent, AccountActivityEventCommentType, IAccountActivityInitialData } from '@modules/members/account-activity/common/types';
import { ACCOUNT_ACTIVITY_ACTION_TYPES } from '@constants/actionTypes/accountActivityActionTypes';

const {
    MEMBER_ACCOUNT_ACTIVITY_DETAILS,
    MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS,
    MEMBER_ACCOUNT_ACTIVITY_LOG_CALL,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE,
    MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY,
    MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
} = configs.endpoints;

export const setAppEventsData = (data: any) => ({
    type: ACCOUNT_ACTIVITY_ACTION_TYPES.SET_APP_EVENTS_DATA,
    payload: data,
});

export const setInitialData = (data: any) => ({
    type: ACCOUNT_ACTIVITY_ACTION_TYPES.SET_INITIAL_DATA,
    payload: data,
});

export const setFiltersData = (data: any) => ({
    type: ACCOUNT_ACTIVITY_ACTION_TYPES.SET_FILTERS_DATA,
    payload: data,
});

export const updateEventComments = (data: any, eventId: string) => ({
    type: ACCOUNT_ACTIVITY_ACTION_TYPES.UPDATE_EVENT_COMMENTS,
    payload: {
        event: data,
        eventId
    }
});

/************************
 # Async action creators
 ************************/
const actions = { setError, startSpinner, stopSpinner };

export const searchAppEvents = ({ payload, applyFilters }) => async (dispatch: Function) => {
    const url = MEMBER_ACCOUNT_ACTIVITY_DETAILS;
    const params = [ url, payload, 'POST', true, undefined, 'application/x-www-form-urlencoded' ];
    const data: IAccountActivityEvent[] = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions);

    if (data) {
        dispatch(setAppEventsData({ activityData: data, currentFilteredData: applyFilters(data) }));
    } else {
        console.error('Cannot searchAppEvents - ', MEMBER_ACCOUNT_ACTIVITY_DETAILS);
        dispatch(stopSpinner());
    }
};

export const getEventComments = ({ payload, eventId }) => async (dispatch: Function) => {
    const url = MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS;
    const params = [ url, payload, 'POST', false, undefined, 'application/x-www-form-urlencoded' ];

    const data: AccountActivityEventCommentType[] = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions);

    if (data) {
        dispatch(updateEventComments(data, eventId));
    } else {
        console.error('Cannot getEventComments - ', MEMBER_ACCOUNT_ACTIVITY_EVENT_COMMENTS);
        dispatch(stopSpinner());
    }
};

export const logACall = (payload, onSuccess) => async dispatch => {
    const url = MEMBER_ACCOUNT_ACTIVITY_LOG_CALL;
    const params = [ url, payload, 'POST', false, undefined, 'application/x-www-form-urlencoded' ];

    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(MEMBER_ACCOUNT_ACTIVITY_LOG_CALL, dispatch, actions);
    onSuccess();
};

export const addNote = ({ id, payload, type }: { id: string; payload: FormData; type: NOTE_TYPES }, refetchComments: () => void) => async dispatch => {
    const url =
        type === NOTE_TYPES.CALL
            ? MEMBER_ACCOUNT_ACTIVITY_ADD_CALL_NOTE.processReplacements({ eventId: id })
            : MEMBER_ACCOUNT_ACTIVITY_ADD_CHAT_NOTE.processReplacements({ eventId: id });
    const params = [ url, payload, 'POST', true, undefined, 'application/x-www-form-urlencoded' ];

    global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions);

    refetchComments();
};

export const exportHistory = ({ encHouseholdId }) => async dispatch => {
    const url = MEMBER_ACCOUNT_ACTIVITY_EXPORT_HISTORY.processReplacements({ encHouseholdId });
    await API.downloadFile(url, dispatch, actions);
};

export const getActivityFilters = ({ encHouseholdId }) => async (dispatch: Function) => {
    try {
        const url = MEMBER_ACCOUNT_ACTIVITY_INIT_CALL.processReplacements({ encHouseholdId });
        const data: { data: IAccountActivityInitialData} = await API.getData(url, dispatch, actions);

        if (data?.data) {
            dispatch(setInitialData({ initialData: data.data }));
            return data;
        } else {
            console.error('Cannot getActivityParams', url);
        }
    } catch (error) {
        console.error('Cannot getActivityParams', error);
    }
};
